import { WebPreferences } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: WebPreferences = {
  hideLoader: false
};
export default (state: WebPreferences, action: ReduxAction<WebPreferences>) => {
  if (!state) {
    state = data;
  }
  switch (action.type) {
    case ReduxType.PREFERENCES:
      return Object.assign({}, state, action.payload);
    case ReduxType.USER_DEFAULT:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};
